import React from "react";
import { Cell } from "react-table";
import { ProductModel } from "src/api/product/product-types";

const IsUsedCell = (props: Cell<ProductModel>) => {
  return <>{props.value === true ? <span className="status B">이용중</span> : <span className="status D">미이용</span>}</>;
};

export default IsUsedCell;
